<template>
  <nav
    class="tw-flex tw-items-center tw-gap-3 tw-text-[#38678c] tw-cursor-pointer tw-mb-3"
    @click="emit('backToLogin')"
  >
    <i class="icon-arrow-left"></i>
    <span>back</span>
  </nav>

  <header class="tw-mb-11">
    <h2 class="tw-text-[1.7rem] tw-font-bold">
      {{ t('auth.titles.forgot_password').toUpperCase() }}
    </h2>
    <p class="tw-text-base tw-font-light">{{ t('auth.titles.enter_reset_password_email') }}</p>
  </header>

  <div
    v-if="isEmailSentSuccessfully"
    class="tw-bg-green-100 tw-border tw-border-green-400 tw-text-green-700 tw-px-4 tw-py-3 tw-rounded tw-mb-4"
    role="alert"
  >
    {{ t('auth.titles.check_email') }}
  </div>

  <Form
    @submit="onSendPasswordResetMail"
    v-slot="{ errors, isSubmitting }"
    class="tw-flex tw-flex-col"
  >
    <div class="tw-mb-7">
      <label for="email" class="tw-text-[0.9rem] tw-mb-1 tw-block">
        {{ t('common.titles.email') }}
      </label>

      <Field
        id="email"
        name="email"
        type="email"
        class="tw-w-full tw-border tw-border-[#d8d8d8] tw-rounded-lg tw-text-[0.9rem] tw-px-3 tw-py-1.5 placeholder:tw-text-[#dcdcdc] placeholder:tw-text-[0.9rem] focus:tw-outline-none"
        :class="{ 'tw-border-danger': errors.email }"
        :placeholder="t('auth.titles.enter_email')"
        :rules="emailRules"
      />

      <div v-if="errors.email" class="tw-text-danger tw-text-xs tw-mt-1">{{ errors.email }}</div>
    </div>

    <button
      class="tw-bg-cta-primary tw-text-white tw-rounded-lg tw-min-h-[2.4rem] disabled:tw-opacity-70"
      :disabled="isSubmitting || isEmailSentSuccessfully"
    >
      {{ t('auth.titles.send_email') }}
    </button>
  </Form>
</template>

<script setup lang="ts">
import { useAuthStore } from '@/stores/auth.store';

import { Form, Field } from 'vee-validate';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { string } from 'yup';

const { t } = useI18n();
const emailRules = string()
  .required(t('auth.titles.email_required'))
  .email(t('auth.titles.email_invalid'));

const emit = defineEmits<{
  (e: 'backToLogin'): void;
}>();

const isEmailSentSuccessfully = ref(false);

const { sendPasswordResetMail } = useAuthStore();

const onSendPasswordResetMail = async (values: any): Promise<void> => {
  await sendPasswordResetMail(values.email);
  isEmailSentSuccessfully.value = true;
};
</script>

<style scoped>
/* Using Tailwind classes - no additional styles needed */
</style>
